module.exports = {
  nUsersAlreadyRegistered: '<strong>1 Person</strong> nimmt bereits teil|<strong>%{participantsCount} Personen</strong> nehmen bereits teil',
  nUsersAlsoRegistered: '<strong>1 Person</strong> nimmt ebenfalls teil|<strong>%{participantsCount} Personen</strong> nehmen ebenfalls teil',
  nOpenSlots: '1 offener Platz|%{openSlots} offene Plätze',
  isFullyBooked: 'Termin ist ausgebucht',
  add_to_calendar: 'Termin zum Kalender hinzufügen',
  show_less: 'Weniger anzeigen',
  show_all: 'Alle anzeigen',
  sortLabels: {
    name_asc: 'Alphabetisch (A-Z)',
    name_desc: 'Alphabetisch (Z-A)',
    relevant: 'Am wichtigsten',
    start_date_desc: 'Datum (neuste zuerst)',
    start_date_asc: 'Datum (älteste zuerst)',
  },
  cancelled: 'Abgesagt',
  cancellationDeadlinePassed: 'Eine Abmeldung ist nicht mehr möglich, da die Abmeldefrist abgelaufen ist.',
  sortShortLabels: {
    name_asc: 'A-Z',
    relevant: 'Am wichtigsten',
    start_date_desc: 'Neuste',
    start_date_asc: 'Älteste',
    name_desc: 'Z-A',
  },
  download_certificate: 'Zertifikat herunterladen',
  your_certificate: 'Dein Zertifikat',
  certificate_preview: 'Zertifikatsvorschau',
  certificate_acquired: 'Zertifikat erhalten',
  with_certificate: 'Mit Zertifikat',
  search_appointment: 'Termine suchen...',
  next_appointments: 'Anstehende Termine',
  unregisteredSuccessfully: 'Du nimmst nicht mehr an diesem Termin teil',
  appointment_details: 'Termin-Details',
  registeredSuccessfully: 'Du bist nun zu diesem Termin angemeldet',
  past: 'Abgelaufen',
  upcoming: 'Anstehend',
  participating: 'Meine Termine',
  appointment_location: 'Veranstaltungsort',
  openSlots: 'offene Plätze',
  appointment_manager: 'Terminmanager',
  noOpenSlots: 'keine offenen Plätze',
  notAllowedToRegister: 'Du besitzt nicht die erforderlichen Berechtigungen, um an diesem Termin teilzunehmen. Bitte wende dich an Deinen Administrator, um die benötigten Rechte zu erhalten.',
  no_appointments_found: 'Keine Termine gefunden',
  online: 'Online',
  youAreRegistered: 'Du nimmst teil',
  register: 'Teilnehmen',
  registrationDeadlineInfo: 'Die Anmeldung ist bis zum %{deadline} möglich',
  registrationDeadlinePastInfo: 'Die Anmeldung war bis zum %{deadline} möglich',
  registrationDeadlinePassed: 'Eine Anmeldung ist nicht mehr möglich, da die Anmeldefrist abgelaufen ist.',
  in_person: 'Präsenz',
  appointments: 'Termin|Termine',
  unregister: 'Abmelden',
  all_appointments: 'Alle Termine',
  elapsed: 'Vergangen',
  last_updated_at: 'Zuletzt aktualisiert am %{date}',
  see_all: 'Alle Termine ansehen',
}
